import React from "react";
import "./Donut.css"; // Ensure you have a corresponding CSS file for styling

const Donut = ({ setChartConfig, chartConfig }) => {
  const handleDonutChange = (key, value) => {
    setChartConfig((prevConfig) => {
      const clone = { ...prevConfig };
      clone.plotOptions = {
        ...clone.plotOptions,
        pie: {
          ...clone.plotOptions?.pie,
          [key]: value
        }
      };
      return clone;
    });
  };

  const handlePaddingChange = (key, value) => {
    setChartConfig((prevConfig) => {
      const clone = { ...prevConfig };
      clone.grid.padding = {
        ...clone.grid.padding,

        [key]: value
      };
      return clone;
    });
  };

  return (
    <div className="donut-settings-container">
      <h3>Donut Settings</h3>

      {/* Donut Size (%) */}
      <div className="donut-settings-section">
        <label className="donut-settings-label">Donut Size (%)</label>
        <input
          type="number"
          min="0"
          max="100"
          value={chartConfig?.plotOptions?.pie?.donut?.size || 65}
          onChange={(e) =>
            handleDonutChange("donut", {
              ...chartConfig?.plotOptions?.pie?.donut,
              size: Number(e.target.value)
            })
          }
        />
      </div>

      {/* Start Angle */}
      <div className="donut-settings-section">
        <label className="donut-settings-label">Start Angle</label>
        <input
          type="number"
          min="0"
          max="360"
          value={chartConfig?.plotOptions?.pie?.startAngle}
          onChange={(e) => handleDonutChange("startAngle", Number(e.target.value))}
        />
      </div>

      {/* End Angle */}
      <div className="donut-settings-section">
        <label className="donut-settings-label">End Angle</label>
        <input
          type="number"
          min="0"
          max="360"
          value={chartConfig?.plotOptions?.pie?.endAngle}
          onChange={(e) => handleDonutChange("endAngle", Number(e.target.value))}
        />
      </div>

      {/* Padding Settings */}
      <div className="donut-settings-section">
        <h4>Padding</h4>

        {/* Top Padding */}
        <div className="donut-settings-subsection">
          <label className="donut-settings-label">Top</label>
          <input
            type="number"
            min="0"
            value={chartConfig?.grid?.padding?.top}
            onChange={(e) => handlePaddingChange("top", Number(e.target.value))}
          />
        </div>

        {/* Right Padding */}
        <div className="donut-settings-subsection">
          <label className="donut-settings-label">Right</label>
          <input
            type="number"
            min="0"
            value={chartConfig?.grid?.padding?.right}
            onChange={(e) => handlePaddingChange("right", Number(e.target.value))}
          />
        </div>

        {/* Bottom Padding */}
        <div className="donut-settings-subsection">
          <label className="donut-settings-label">Bottom</label>
          <input
            type="number"
            min="0"
            value={chartConfig?.grid?.padding?.bottom}
            onChange={(e) => handlePaddingChange("bottom", Number(e.target.value))}
          />
        </div>

        {/* Left Padding */}
        <div className="donut-settings-subsection">
          <label className="donut-settings-label">Left</label>
          <input
            type="number"
            min="0"
            value={chartConfig?.grid?.padding?.left}
            onChange={(e) => handlePaddingChange("left", Number(e.target.value))}
          />
        </div>
      </div>
    </div>
  );
};

export default Donut;
